import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      const main = document.querySelector('main') || document.querySelector('.main-content') || document.querySelector('.faq-page');
      if (main) {
        main.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      }
    }, 50);
  }, [pathname]);



  return null;
}
